import React, { FunctionComponent, useState } from "react";
import UploadComponent, { UploadAction } from "./excelComponents/UploadComponent";
import { styled, Typography } from "@mui/material";
import { ModalCloseButton } from "components/public/Modal";
import { useDispatch } from "react-redux";
import { appCloseModal } from "store/actions/appAction";
import RoundedcheckIcon from "assets/icons/RoundedcheckIcon";
import SynchronizeComponent, { SynchronizeAction } from "./excelComponents/SynchronizeComponent";
import EnterInfoComponent, { EnterInfoAction } from "./excelComponents/EnterInfoComponent";
import { Formik } from "formik";

const ImportExcelModalContainer = styled("div")(({ theme }) => ({
  // height: '672px',
  display: "grid",
  gridTemplateRows: "10% 80% 10%",
}));
const Header = styled("div")(({ theme }) => ({
  height: "100%",
  display: "flex",
  padding: "0 24px",
  justifyContent: "space-between",
  alignItems: "center",
  borderBottom: `solid 4px ${theme.palette.disabled.light}`,
}));
const Nav = styled("div")(({ theme }) => ({
  width: "288px",
  height: "28px",
  borderRadius: "20px",
  overflow: "hidden",
  backgroundColor: "#F5F7FA",
  display: "grid",
  gridTemplateColumns: "33% 33% 33%",
}));
const RightHeader = styled("div")(({ theme }) => ({
  width: "338px",
  display: "flex",
  height: "28px",
  justifyContent: "space-between",
}));

interface indicatorInterface {
  passed?: boolean;
  active?: boolean;
}

const Indicator = styled("div")<indicatorInterface>(({ theme, passed, active }) => ({
  width: "100%",
  display: "flex",
  height: "100%",
  fontSize: "12px",
  padding: "6px 0 6px 12px",
  justifyContent: "space-evenly",
  lineHeight: "16px",
  fontWeight: active ? "bold" : "normal",
  color: active ? theme.palette.primary.main : passed ? "#00367E" : "#7E8C9E",
  borderRadius: active ? "20px 0 0 20px" : 0,
  backgroundColor: active || passed ? "#E7EFFC" : "",
  textAlign: "center",
}));
const ActionContainer = styled("div")(({ theme }) => ({
  width: "100%",
  zIndex: 2,
  height: "100%",
  backgroundColor: "#F5F7FA",
  padding: "0 24px",
}));
const BodyContainer = styled("div")(({ theme }) => ({
  width: "100%",
  height: "100%",
  padding: "28px 24px",
}));

interface ActionComponentinterface {
  onSubmit: () => void;
  onIgnore: () => void;
}

type stepStatus = {
  key: string;
  title: string;
  navTitle: string;
  Component: React.FC;
  ActionComponent: ({ onSubmit, onIgnore }: { onSubmit: () => void; onIgnore: () => void }) => JSX.Element;
};

const stepItems: stepStatus[] = [
  {
    key: "upload",
    title: "آپلود فایل اکسل",
    navTitle: "آپلود فایل",
    Component: UploadComponent,
    ActionComponent: UploadAction,
  },
  {
    key: "synchronize",
    title: "همگام سازی ستون ها",
    navTitle: "همگام سازی",
    Component: SynchronizeComponent,
    ActionComponent: SynchronizeAction,
  },
  {
    key: "enter",
    title: "ثبت اطلاعات در سرور",
    navTitle: "ثبت اطلاعات",
    Component: EnterInfoComponent,
    ActionComponent: EnterInfoAction,
  },
];
const ImportExcelModal = () => {
  const [step, setStep] = useState<stepStatus>(stepItems[0]);
  // @ts-ignore
  const { Component, ActionComponent } = step;

  const index = stepItems.findIndex((item) => item.key === step.key);
  const forwardStep = () => {
    if (index < stepItems.length - 1) setStep(stepItems[index + 1]);
  };
  const dispatch = useDispatch();
  const backStep = () => {
    if (index === 0 || index === stepItems.length - 1) dispatch(appCloseModal());
    if (index !== 0) setStep(stepItems[index - 1]);
  };
  const initialValues = {};
  const onSubmit = () => {};

  return (
    <ImportExcelModalContainer>
      <Header>
        <Typography>{step?.title}</Typography>
        <RightHeader>
          <Nav>
            {stepItems.map((item, key) => {
              return (
                <Indicator active={step.key === item.key} passed={key < index} key={key}>
                  {item.navTitle}
                  {key < index && <RoundedcheckIcon />}
                </Indicator>
              );
            })}
          </Nav>
          {/*<ModalCloseButton />*/}
        </RightHeader>
      </Header>
      <Formik initialValues={initialValues} onSubmit={onSubmit}>
        {(formik) => (
          <>
            <BodyContainer>
              <Component />
            </BodyContainer>
            <ActionContainer>
              <ActionComponent onSubmit={forwardStep} onIgnore={backStep} />
            </ActionContainer>
          </>
        )}
      </Formik>
    </ImportExcelModalContainer>
  );
};

export default ImportExcelModal;
